module.exports = __webpack_public_path__ + "static/img/SmileAnimation_strawberry.6c33c6c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/SmileAnimation_strawberry.gif
// module id = dOPp
// module chunks = 0